import faLocale from "./fa";

const locales = {
    fa: faLocale,
};

export default locales;
